import { render } from "./VideoSc.vue?vue&type=template&id=5cacb2a3&scoped=true"
import script from "./VideoSc.vue?vue&type=script&lang=js"
export * from "./VideoSc.vue?vue&type=script&lang=js"

import "./VideoSc.vue?vue&type=style&index=0&id=5cacb2a3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cacb2a3"]])

export default __exports__